import { useApiClient } from '../client.js'
import qs from 'qs'

export const GET_CONFIG_ENDPOINT = '/config'

export function getConfig (country) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_CONFIG_ENDPOINT,
    params: {
      country,
    },
    paramsSerializer: qs.stringify,
  })
}
